/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiUpdateUserAlertRfiMessageNotifications,
    InternalApiUpdateUserAlertRfiMessageNotificationsFromJSON,
    InternalApiUpdateUserAlertRfiMessageNotificationsToJSON,
    InternalApiUserAlertRfiMessageNotifications,
    InternalApiUserAlertRfiMessageNotificationsFromJSON,
    InternalApiUserAlertRfiMessageNotificationsToJSON,
} from '../models';

export interface UpdateAlertRfiMessageNotificationsRequest {
    internalApiUpdateUserAlertRfiMessageNotifications: InternalApiUpdateUserAlertRfiMessageNotifications;
}

/**
 * 
 */
export class UserAlertRfiMessageNotificationApi extends runtime.BaseAPI {

    /**
     * Finds user alert rfi message notification configurations
     */
    async findAlertRfiMessageNotificationsRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiUserAlertRfiMessageNotifications>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/users/alert-rfi-notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiUserAlertRfiMessageNotificationsFromJSON(jsonValue));
    }

    /**
     * Finds user alert rfi message notification configurations
     */
    async findAlertRfiMessageNotifications(initOverrides?: RequestInit): Promise<InternalApiUserAlertRfiMessageNotifications> {
        const response = await this.findAlertRfiMessageNotificationsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates user alert rfi message notification configurations
     */
    async updateAlertRfiMessageNotificationsRaw(requestParameters: UpdateAlertRfiMessageNotificationsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiUserAlertRfiMessageNotifications>> {
        if (requestParameters.internalApiUpdateUserAlertRfiMessageNotifications === null || requestParameters.internalApiUpdateUserAlertRfiMessageNotifications === undefined) {
            throw new runtime.RequiredError('internalApiUpdateUserAlertRfiMessageNotifications','Required parameter requestParameters.internalApiUpdateUserAlertRfiMessageNotifications was null or undefined when calling updateAlertRfiMessageNotifications.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/users/alert-rfi-notifications`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiUpdateUserAlertRfiMessageNotificationsToJSON(requestParameters.internalApiUpdateUserAlertRfiMessageNotifications),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiUserAlertRfiMessageNotificationsFromJSON(jsonValue));
    }

    /**
     * Updates user alert rfi message notification configurations
     */
    async updateAlertRfiMessageNotifications(requestParameters: UpdateAlertRfiMessageNotificationsRequest, initOverrides?: RequestInit): Promise<InternalApiUserAlertRfiMessageNotifications> {
        const response = await this.updateAlertRfiMessageNotificationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
